import React from "react";
import { connect } from "react-redux";
import SupplierCard from './SupplierCard';
import AddSupplier from './addSupplier';
import { Row, Col, Button,Form ,Modal, Spinner} from 'react-bootstrap';
import ReactLoading from 'react-loading';
import { getAllAdminSuppliers,addSupplier,getSupplier,editSupplier,deleteSupplier,filterSuppliers,
closeOpenedPart,closeError,getAllAdminParts} from '../../js/actions'

import OpenSupplier from "./openSupplier"

import Navbar from '../Common/Navbar'
import { sort_by_field } from "../../globals";

class Suppliers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            shipping_co:'', country:"", addPartModal: false, 
            wh: null, del_err:false
        };
       
    }
    componentDidMount = () => {
        this.props.getAllAdminSuppliers();
        //this.props.getAllAdminParts();
    }
    search = (e) => {
        e.preventDefault();
        const { country } = this.state;
        this.props.filterSuppliers({ country: country});
    }

   
    renderSuppliers = () => {
        const { all_suppliers, filter_applied,filtered_items,suppliers_success } = this.props;
        if (filter_applied) {
            if(filtered_items.length > 0){
                return (sort_by_field(filtered_items,'supplier_name').map((p, i) => {
                    return (
                            <SupplierCard supplier={p} key={i} deleteSupplier={this.deleteSupplierById}  openSupplier={this.openSupplier}/>
                    )
                }))
            }
          

        }
        else {
            if(suppliers_success){
                return (
                    sort_by_field(all_suppliers,'supplier_name').map((p, i) => {
                        return (
                                <SupplierCard supplier={p} key={i} openSupplier={this.openSupplier} />
    
                        )
                    })
                )
            }
            else{
                return ( <ReactLoading type={'spin'} height='2em' width='2em' color={'#2E5BFF'}  />)
            }
            

        }
    }

    openSupplier = (id) => {
        this.props.getSupplier({ id: `${id}` });
    }
    addSupplier = (data) => {
    
        this.props.addSupplier(data)
        this.setState({ addPartModal: false });
        this.props.getAllAdminSuppliers();
    }
    deleteSupplierById = (id) => {
        const{parts}=this.props;
        let {del_err}=this.state;
        
        del_err=parts.find(p=>{
            if(p.supplier_id===id){
                alert('This Supplier is connected to existing parts. Delete those parts and try again') 
                return true;
                }
        })
        if(del_err != undefined){
            this.setState({del_err})
        }
        else{
            this.props.deleteSupplier({ id: `${id}` }); 
        }
        console.log(del_err)
        this.props.closeOpenedPart();
    }


    render() {
        const { all_suppliers,supplier } = this.props;
        const { country,addPartModal,del_err } = this.state;

        const { error, err_msg, success_msg, closeError ,openConfirm,open_item_modal,closeOpenedPart} = this.props;
       
        if(localStorage.getItem("loginState")=="false" && localStorage.getItem("admin_login")=="false"){
            this.props.history.push("/admin/");
            return null;
          }
        else
            return (
                <React.Fragment>
                <Row>
                    <Navbar active="suppliers" />
                    <Col>
                        <Row className="top-header">

                        </Row>

                        <Row className="parts-main">
                            <Col md="10">
                                <Row>
                                    <Col><h2>Suppliers</h2></Col>
                                    <Col><p className='gray_text pt-3'>{all_suppliers.length} Total</p></Col>
                                    <Col> <Button variant="primary" className="add-part-btn" onClick={() => { this.setState({ addPartModal: true }) }}>+ Supplier</Button></Col>
                                </Row>
                               <div id='labels'>
                                <Col style={{padding:0}}><p className='gray_text text-uppercase'>Name</p></Col>
                                <Col style={{padding:0}}><p className='gray_text text-uppercase'>City</p></Col>
                                <Col style={{padding:0}}><p className='gray_text text-uppercase'>Country</p></Col>
                                </div>
                                
                                <div style={{overflow:'scroll',height:'70vh',padding:10}}>
                                {
                                    this.renderSuppliers()
                                }
                                </div>

                            </Col>

                            <Col md="2" className="parts-filter">
                                <p>FILTER</p>
                                    <Form onSubmit={this.search}>

                                    <Form.Group>
                                        <p className='gray_text  bold text-uppercase'>Country</p>
                                        <Form.Control id="country" value={country} onChange={(e)=>{this.setState({country:e.target.value})}} placeholder="Enter Country" />
                                    </Form.Group>
                                        
                                        <button className="btn btn-primary search-btn">Search</button>
                                    </Form>
                               
                            </Col>

                            <AddSupplier show={addPartModal} onHide={() => { this.setState({ addPartModal: false }) }}
                               addSupplier={this.addSupplier}  />

                            <OpenSupplier supplier={supplier} show={open_item_modal} onHide={closeOpenedPart}
                            deleteSupplier={this.deleteSupplierById} />

                        </Row>
                    </Col>

                </Row>

               
                </React.Fragment>





            )


    }
}
const mapDispatchToProps = dispatch => {
    return {
        getAllAdminSuppliers: payload => dispatch(getAllAdminSuppliers()),
        getAllAdminParts: payload => dispatch(getAllAdminParts()),
        addSupplier: payload => dispatch(addSupplier(payload)),
        getSupplier: payload => dispatch(getSupplier(payload)),
        editSupplier: payload => dispatch(editSupplier(payload)),
        deleteSupplier: payload => dispatch(deleteSupplier(payload)),
        filterSuppliers: payload => dispatch(filterSuppliers(payload)),

        closeError: payload => dispatch(closeError()),
        closeOpenedPart:payload => dispatch(closeOpenedPart()),
        
    }
}
const mapStateToProps = state => {
    return { all_suppliers: state.all_suppliers, supplier:state.supplier,
        filtered_items: state.filtered_items, filter_applied: state.filter_applied,
        error: state.error, err_msg: state.err_msg, success_msg: state.success_msg,openConfirm:state.openConfirm,
        open_item_modal: state.open_item_modal,
        parts: state.parts,
        suppliers_success:state.suppliers_success
        }
}

export default connect(mapStateToProps, mapDispatchToProps)(Suppliers);
